.wrapper {
  border-radius: var(--profile-image-radius);
  display: inline-block;
  height: var(--profile-image-size);
  overflow: hidden;
  width: var(--profile-image-size);
}

.image {
  border-radius: var(--profile-image-radius);
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.small {
  --profile-image-size: 32px;
  width: 32px;
}

.medium {
  --profile-image-size: 50px;
  width: 50px;
}

.large {
  --profile-image-size: 120px;
  width: 120px;
}

.xl {
  --profile-image-size: 300px;
  height: auto;
  max-width: 100%;
  width: 300px;
}

.journey-card {
  --profile-image-size: 150px;
  width: 150px;
}

.journey-card-mobile {
  --profile-image-size: 64px;
  width: 64px;
}
